import { useNavigate } from 'react-router-dom';
import '../styles/LegalPage.css';

function RefundPolicy() {
    const navigate = useNavigate();

    return (
        <div className="legal-page">
            <div className="legal-container">
                <button className="legal-back" onClick={() => navigate(-1)}>
                    &larr; Back
                </button>

                <h1>Refund Policy</h1>
                <p className="legal-updated">Last Updated: June 7, 2026</p>

                <section>
                    <h2>1. Subscriptions</h2>
                    <p>
                        PrimeMaxing offers monthly and annual subscription plans for premium access
                        to the Service. You may cancel your subscription at any time through the
                        billing portal or by contacting us.
                    </p>

                    <h3>Monthly Subscriptions</h3>
                    <p>
                        When you cancel a monthly subscription, your access continues through the
                        end of the current billing period. No refund is issued for the remaining
                        days of that period.
                    </p>

                    <h3>Annual Subscriptions</h3>
                    <p>
                        When you cancel an annual subscription, your access continues through the
                        end of the current billing period. No partial refunds are issued for
                        unused time remaining in the subscription term.
                    </p>

                    <h3>Elite Memberships</h3>
                    <p>
                        Elite members who wish to end their services immediately, rather than at
                        the end of the current term, may be eligible for a prorated refund at our
                        discretion. Contact support to request an immediate cancellation review.
                    </p>
                    <p>
                        Approved early cancellations are refunded based on the unused portion of
                        the Elite membership fee, <strong>less</strong>:
                    </p>
                    <ul>
                        <li>the value of products ordered (including supplements shipped or in fulfillment),</li>
                        <li>lab tests ordered or performed,</li>
                        <li>physician review appointments used or scheduled, and</li>
                        <li>a processing fee.</li>
                    </ul>
                    <p>
                        Upon early cancellation, the Elite membership is converted to a standard
                        Annual subscription rather than terminated &mdash; platform access
                        continues at the Annual tier for the remainder of the term.
                    </p>
                </section>

                <section>
                    <h2>2. Blood Test Purchases</h2>
                    <p>
                        Blood test orders include a lab requisition that is sent to you
                        electronically. Once the requisition has been delivered, the purchase is
                        non-refundable regardless of whether the requisition has been used.
                    </p>
                    <p>
                        If your order has not yet been processed and no requisition has been sent,
                        you may request a full refund by contacting us.
                    </p>
                </section>

                <section>
                    <h2>3. Supplement &amp; Product Orders</h2>
                    <p>
                        Physical products, such as supplements, may be refunded under the
                        following conditions:
                    </p>
                    <p>
                        <strong>Canceled before shipping.</strong> Orders canceled before they
                        have shipped are eligible for a full refund. Contact us as soon as
                        possible &mdash; once an order has shipped, it can no longer be canceled.
                    </p>
                    <p>
                        <strong>Returned unused.</strong> In some cases, products returned in an
                        unused, unopened state may be eligible for a refund at our discretion.
                        Contact support before returning any product; returns sent without prior
                        approval may not be refunded. Return shipping costs are the customer's
                        responsibility unless the return is due to our error.
                    </p>
                    <p>
                        <strong>Damaged or incorrect orders.</strong> If your order arrives
                        damaged, defective, or is not what you ordered, we will replace it or
                        issue a full refund, including shipping costs. Please report the issue
                        within 14 days of delivery with a photo of the damaged item.
                    </p>
                </section>

                <section>
                    <h2>4. Promotional Codes &amp; Discounts</h2>
                    <p>
                        Purchases made with promotional codes, discount codes, or complimentary
                        access are non-refundable. If a promotional code provided a partial
                        discount, only the amount actually paid is eligible for refund under the
                        terms above.
                    </p>
                </section>

                <section>
                    <h2>5. How to Request a Refund</h2>
                    <p>
                        To request a refund, please contact us at:
                    </p>
                    <p>
                        <strong>PrimeMaxing</strong><br />
                        Email: support@primemaxing.com
                    </p>
                    <p>
                        Please include your account email and a description of the purchase.
                        Refund requests are typically processed within 5&ndash;10 business days.
                        Refunds are issued to the original payment method.
                    </p>
                </section>

                <section>
                    <h2>6. Changes to This Policy</h2>
                    <p>
                        We may update this Refund Policy from time to time. Material changes will
                        be communicated through the Service or by email. The updated policy
                        applies to purchases made after the effective date of the change.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default RefundPolicy;
